import type { ProgressState } from "@/hooks/useBorrowerRealtime";
import type { AnalysisRunListItem } from "@/types/analysisRun";

const TERMINAL_PROGRESS = new Set(["completed", "error", "failed"]);

/**
 * Page-level toast seed from the analysis-run list so a refresh still shows
 * in-flight statement analysis. Plaid runs stay on PlaidProcessingPublisher.
 */
export function statementAnalysisProgressFromRuns(
  runs: Pick<AnalysisRunListItem, "status" | "source" | "created_at">[] | undefined
): ProgressState | null {
  const run = (runs ?? []).find(
    (row) => row.status === "processing" && row.source === "statements"
  );
  if (!run) return null;
  return {
    taskType: "underwriting_analysis",
    status: "processing",
    message: "Running statement analysis...",
    startedAt: run.created_at,
  };
}

/** Prefer the live websocket snapshot; fill startedAt from the run when WS omitted it. */
export function mergeLiveAndFetchedProgress(
  live: ProgressState | null,
  fetched: ProgressState | null
): ProgressState | null {
  if (live && !TERMINAL_PROGRESS.has(live.status)) {
    if (live.startedAt || !fetched?.startedAt) return live;
    return { ...live, startedAt: fetched.startedAt };
  }
  return fetched;
}
